import { useQuery, useSubscription } from "@apollo/react-hooks";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import {
  MY_LEAVE_GET_ORPHANED_REQUESTS_LIST_COUNT,
  MY_LEAVE_REQUESTS_SUBSCRIPTION,
} from "my-leave/graphql";
import { useOcCurrentUserState, useOcPolling } from "oc/hooks";

export const useMyLeaveAdminBadges = () => {
  let { contractCode } = useOcCurrentUserState();
  const { hasRole } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  let allowedRoles = ["MyLeave.admin"];
  let notAllowedRoles: string[] = [];

  let hasRight = hasRole(allowedRoles, notAllowedRoles);

  const { data, loading, error, refetch } = useQuery(
    MY_LEAVE_GET_ORPHANED_REQUESTS_LIST_COUNT,
    {
      skip: !contractCode || !hasRight,
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      variables: { contract: contractCode },
    },
  );

  if (error) {
    console.log({
      component: "useMyLeaveAdminBadges",
      errorDescription:
        "Error occured when fetch data with MY_LEAVE_GET_ORPHANED_REQUESTS_LIST_COUNT query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_LEAVE_REQUESTS_SUBSCRIPTION,
    {
      skip: !contractCode || !hasRight,
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useMyLeaveAdminBadges",
      errorDescription:
        "Error occured when subscribe data with MY_LEAVE_REQUESTS_SUBSCRIPTION query",
      error: error,
    });
  }

  return {
    data: data?.orphanedRequestsCount,
    loading: loading || false,
    error: error || undefined,
  };
};

export default useMyLeaveAdminBadges;
